import React, {useEffect, useState} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import moment from "moment/moment";

const initialModuleData = {
    name: '',
    start: moment(),
    end: moment(),
    contract: '',
    assortment: '',
    unlimitedStock: false
};

const CreateModuleModal = (props) => {

    const [moduleData, setModuleData] = useState(initialModuleData);
    const [formErrors, setFormErrors] = useState({});

    useEffect(() => {
        setModuleData(initialModuleData);
        setFormErrors({});
    }, [props.visible]);

    const cancel = () => {
        setModuleData(initialModuleData);
        props.onCancel();
    };

    const setProperty = (propertyName, propertyValue) => {
        const property = {[propertyName]: propertyValue};
        setModuleData(prevModuleData => {return {...prevModuleData, ...property}});
    };

    const validate = () => {
        let complete = true;
        let formErrors = {};

        if (moduleData.name === '') {
            formErrors['name'] = true;
            complete = false;
        }
        if (moduleData.end.isBefore(moduleData.start)) {
            formErrors['end'] = true;
            formErrors['start'] = true;
            complete = false;
        }
        setFormErrors(formErrors);
        return complete;
    };

    const submit = () => {
        if (validate()) {
            const module = {
                name: moduleData.name,
                start: moduleData.start.format('YYYY-MM-DDTHH:mm:00'),
                end: moduleData.end.format('YYYY-MM-DDTHH:mm:00'),
                contract: moduleData.contract,
                assortment: moduleData.assortment,
                unlimitedStock: moduleData.unlimitedStock
            };
            props.onSubmit(module);
        }
    };

    return (
        <Modal isOpen={props.visible} centered={true} className={props.className}>
            <ModalHeader>Neues Modul</ModalHeader>
            <ModalBody>
                <div className="row">
                    <div className="col-lg-12">
                        <form>
                            <div className="form-group">
                                <label htmlFor="csModalModuleName">Modulbezeichnung*</label>
                                <input type="text" className={"form-control " + (formErrors.name ? 'is-invalid' : '')}id="csModalModuleName"
                                       onChange={(event) => setProperty('name', event.target.value)}
                                       placeholder="Name..." required={true}/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="csModalModuleStart">Beginn Nachversorgungszeitraum*</label>
                                <input type="date" className={"form-control " + (formErrors.start ? 'is-invalid' : '')} id="csModalModuleStart"
                                       value={moduleData.start.format("YYYY-MM-DD")}
                                       onChange={(event) => setProperty('start', moment(event.target.value, "YYYY-MM-DD"))}
                                       required={true}/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="csModalModuleEnd">Ende Nachversorgungszeitraum*</label>
                                <input type="date" className={"form-control " + (formErrors.end ? 'is-invalid' : '')} id="csModalModuleEnd"
                                       value={moduleData.end.format("YYYY-MM-DD")}
                                       onChange={(event) => setProperty('end', moment(event.target.value, "YYYY-MM-DD"))}
                                       required={true}/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="csModalModuleContract">Kontrakt</label>
                                <input type="text" className="form-control" id="csModalModuleContract"
                                       onChange={(event) => setProperty('contract', event.target.value)}
                                       placeholder="Kontrakt..." required={false}/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="csModalModuleAssortment">Sortiment</label>
                                <input type="text" className="form-control" id="csModalModuleAssortment"
                                       onChange={(event) => setProperty('assortment', event.target.value)}
                                       placeholder="Sortiment..." required={false}/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="csModalModuleUnlimitedStock">NOS</label>
                                <input type="checkbox" className="form-control" id="csModalModuleUnlimitedStock"
                                       onChange={(event) => setProperty('unlimitedStock', event.target.value)}
                                       value={true} required={false}/>
                            </div>
                        </form>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={submit}>Modul erstellen</Button>{' '}
                <Button color="secondary" onClick={cancel}>Abbrechen</Button>
            </ModalFooter>
        </Modal>
    );
};

export default CreateModuleModal;



// WEBPACK FOOTER //
// ./src/admin/module/overview/CreateModuleModal.js